import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem('cf_token');
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      api.get('/auth/me')
        .then(res => setUsuario(res.data))
        .catch(() => { sessionStorage.removeItem('cf_token'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, senha) => {
    const { data } = await api.post('/auth/login', { email, senha });
    sessionStorage.setItem('cf_token', data.token);
    api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    setUsuario(data.usuario);
    return data;
  };

  const logout = () => {
    sessionStorage.removeItem('cf_token');
    delete api.defaults.headers.common['Authorization'];
    setUsuario(null);
  };

  const updateUsuario = (u) => setUsuario(prev => ({ ...prev, ...u }));

  const isViewer = !!(usuario && usuario.is_viewer);

  return (
    <AuthContext.Provider value={{ usuario, loading, login, logout, updateUsuario, isViewer }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
